import BaseModel from "../../core/components/input-widget/BaseModel";

export default class ContractSend extends BaseModel {
  recipients = []

  constructor(data = {}) {
    super();
    Object.assign(this, {...data});
  }

  rules = {
  };

  attributeHints = {
  };

  attributeLabels = {
  };
}
